import {http} from './config/config-relation-register'

export default{
    listar:(token,itens_pagina,pagina,filter)=>{
        if(itens_pagina,pagina){
            return  http.get('itens-produto?itens_pagina='+itens_pagina+'&pagina='+pagina+'&filter='+encodeURIComponent(filter),{
                headers:{
                    'Authorization':token
                }
            })
        }else{
            return  http.get('itens-produto',{
                headers:{
                    'Authorization':token
                }
            })
        }
    },
    salvar:(token, item)=>{
        return http.post('itens-produto',item,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idItem)=>{
        return http.delete('itens-produto/'+idItem,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, item)=>{
        return http.put('itens-produto/'+item.id_item_produto,item,{
            headers:{
                'Authorization':token
            }
        })
    },
    salvarEquipament:(token, itens)=>{
        return http.post('itens-produto/save-equipament',itens,{
            headers:{
                'Authorization':token
            }
        })
    },
}